{
    "deleteUser": {}
}